<template>
    <modal v-if="dialog" @close="close" width="800px">
        <template slot="header">
            <h4 class="modal-title">Ajuste de demanda</h4>
            <md-button
                class="md-simple md-just-icon md-round modal-default-button"
                @click="close"
            >
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <div class="main-content md-layout">
                <div class="md-layout-item md-size-75 md-small-size-75">
                    <Chart
                        v-bind:demands="demands"
                        v-bind:historicSalesMonth="historicSalesMonth"
                        v-bind:historicStocksMonth="historicStocksMonth"
                        :onHandleActiveDemand="handleActiveDemand"
                        :onHandleDrop="handleDrop"
                    />
                    <ColumnChart
                        v-bind:historicSalesDiary="historicSalesDiary"
                        v-bind:historicStocksDiary="historicStocksDiary"
                    />
                </div>

                <div class="md-layout-item md-size-25 md-small-size-25">
                    <TextField :fields="amount" />
                    <SelectField cols="12" :fields="recurrence" />
                    <TimeField
                        color="#0077c8"
                        placeholder="00/00/0000"
                        :cols="12"
                        outerLabel="Não perturbe até"
                        @input="napDate"
                    />
                    <div class="float-right mt-6">
                        <Button
                            label="Cancelar"
                            type="secondary"
                            class="mr-3"
                            v-on:click.native="close"
                        />
                        <Button
                            label="Salvar"
                            v-on:click.native="handleSave"
                            :loading="loading"
                        />
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>
<script>
import TextField from '@/components/Inputs/TextField'
import SelectField from '@/components/Inputs/SelectField'
import TimeField from '@/components/Inputs/TimeField.vue'
import Button from '@/components/Button/Button.vue'
import Chart from '@/components/Charts/Demand'
import ColumnChart from '../Charts/ColumnChart.vue'
import { mapState, mapActions } from 'vuex'
import { Modal } from '@/components'
import moment from 'moment'

export default {
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        close: {
            type: Function
        },
        product_id: {
            type: Number
        },
        branch_id: {
            type: Number
        },
        demand_id: {
            type: Number
        }
    },
    components: {
        TextField,
        SelectField,
        TimeField,
        Button,
        Chart,
        Modal,
        ColumnChart
    },
    computed: {
        ...mapState({
            _demands: state => state['demands'].demands,
            historicSales: state => state['sales'].historicSales,
            historicStocks: state => state['stock'].historicStocks
        })
    },
    methods: {
        ...mapActions('sales', {
            readHistoricSales: 'readHistoricSales'
        }),
        ...mapActions('demands', {
            readDemands: 'readDemands',
            createDemands: 'create',
            updateDemands: 'update'
        }),
        ...mapActions('stock', {
            readHistoricStocks: 'readHistoricStocks'
        }),

        async fetchHistoricSales() {
            await this.readHistoricSales({
                product: this.product_id,
                historic_size: 9,
                branch_id: this.branch_id,
                aggregation_type: 'month'
            })

            this.historicSalesMonth = this.historicSales

            await this.readHistoricSales({
                product: this.product_id,
                historic_size: 3,
                branch_id: this.branch_id,
                aggregation_type: 'day'
            })

            this.historicSalesDiary = this.historicSales
        },

        async fetchDemands() {
            await this.readDemands({
                product_id: this.product_id,
                historic_size: 3,
                branch_id: this.branch_id,
                aggregation_type: 'week'
            })
            this.demands = this._demands
            this.series = this.demands
        },

        async fetchHistoricStocks() {
            await this.readHistoricStocks({
                product: this.product_id,
                historic_size: 9,
                branch_id: this.branch_id,
                aggregation_type: 'month'
            })
            this.historicStocksMonth = this.historicStocks
            await this.readHistoricStocks({
                product: this.product_id,
                historic_size: 3,
                branch_id: this.branch_id,
                aggregation_type: 'day'
            })
            this.historicStocksDiary = this.historicStocks
        },

        async handleSave() {
            if (!this.edit_chart) {
                if (!this.amount.text) {
                    this.$notify({
                        message: 'Quantidade inválida',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                } else if (
                    Array.isArray(this.recurrence.selected) ||
                    !this.recurrence.selected
                ) {
                    this.$notify({
                        message: 'Recorrência inválida',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                } else {
                    this.loading = true
                    await this.createDemands({
                        quantity: this.amount.text,
                        aggregation_type: this.recurrence.selected,
                        datetime_nap: this.napDate,
                        branch_id: this.branch_id,
                        product_id: this.product_id,
                        status: 'active'
                    })
                    await this.readDemands({
                        product_id: this.product_id,
                        historic_size: 3,
                        branch_id: this.branch_id,
                        aggregation_type: 'week'
                    })
                    this.demands = this._demands
                    this.loading = false
                    this.resetValues()
                    this.close()
                }
            } else {
                this.loading = true
                const index = this.series.findIndex(
                    serie => serie[0][0][2] === this.active_demand_id
                )
                const data = this.series[index][0].map(item => ({
                    // interval: new Date(item[0]).getMonth() + 1,
                    interval: moment(new Date(item[0])).week(),
                    year: new Date(item[0]).getFullYear(),
                    quantity: item[1]
                }))
                await this.updateDemands({
                    demand_id: this.active_demand_id,
                    status: 'active',
                    quantity: data
                })
                this.loading = false
                this.resetValues()
                this.close()
            }
        },

        handleActiveDemand(demand) {
            this.active_demand_id = demand.demand_id
            this.edit_chart = true
        },

        handleDrop(series) {
            this.edit_chart = true
            this.series = series
        },

        resetValues() {
            this.amount = {
                outerLabel: 'Quantidade',
                text: '300'
            }
            this.recurrence = {
                outerLabel: 'Recorrência',
                answers: [
                    { label: 'Diário', value: 'day' },
                    { label: 'Semanal', value: 'week' }
                ],
                selected: []
            }
            this.napDate = ''
            this.historicSalesMonth = {}
            this.historicSalesDiary = {}
            this.historicStocksMonth = {}
            this.historicStocksDiary = {}
            this.demands = {}
            this.loading = false
            this.active_demand_id = this.demand_id
            this.edit_chart = false
        }
    },
    data() {
        return {
            amount: {
                outerLabel: 'Quantidade',
                text: '300'
            },
            recurrence: {
                outerLabel: 'Recorrência',
                answers: [
                    { label: 'Diário', value: 'day' },
                    { label: 'Semanal', value: 'week' }
                ],
                selected: []
            },
            napDate: '',
            historicSalesMonth: {},
            historicSalesDiary: {},
            historicStocksMonth: {},
            historicStocksDiary: {},
            demands: {},
            loading: false,
            active_demand_id: null,
            edit_chart: false,
            series: []
        }
    },
    watch: {
        dialog: {
            handler: async function(newValue, oldValue) {
                if (newValue) {
                    this.resetValues()
                    await this.fetchHistoricSales()
                    await this.fetchHistoricStocks()
                    await this.fetchDemands()
                }
            },
            deep: true
        }
    }
}
</script>
<style scoped>
.flex {
    border-left: 1px solid rgb(175, 175, 175);
}
.title {
    color: #3a3939;
    font-family: Inter;
    font-weight: 800;
    font-size: 14px;
}

.columnChart {
    position: relative;
    height: 100px;
    width: 100%;
}
</style>

<style>
.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: unset;
    transform: unset;
}

.modal-container {
    max-width: 1300px;
}
</style>
